export function getMask(str: string) {
  const len = str.length;

  if (len >= 10) {
    return '+7 999 999-99-99';
  } else if (len >= 8) {
    return '+7 999 999-99 99';
  } else {
    return '+7 999 999 99 99';
  }
}
